import { useDateViewScrollDirection } from '../useScrollDirection/useDateViewScrollDirection';

function useDateViewCombiner() {
  useDateViewScrollDirection();
}

export { useDateViewCombiner };
